import './spinbox.js';
import './styles/spinbox.scss';
